import React from 'react';
import events from 'lib/events';

// Higher order component to fully reload component and all data
// on locale change: useful to remove cached dropdowns in reports, etc.
export function bindLocaleUpdate(C) {
  return class Bound extends React.Component {
    displayName = `bindLocaleUpdate(${C.displayName || C.name})`;

    state = {
      version: 1,
    };

    componentWillMount() {
      this.sub = events.subscribe('locale.changed',
        () => this.setState(prevState => ({version: prevState.version + 1})));
    }

    componentWillUnmount() {
      if (this.sub && this.sub.remove) {
        this.sub.remove();
      }
    }

    render() {
      return <C key={this.state.version} {...this.props} />;
    }
  };
}
